import React from 'react';
import { motion } from 'framer-motion';
import { Wind, Mic, BedDouble } from 'lucide-react';
export function MechanismReveal() {
  const zones = [{
    id: '01',
    title: 'Nase',
    desc: 'Luft kommt nicht sauber durch → Mund geht auf',
    icon: <Wind className="w-6 h-6 text-[#0f172a]" data-id="element-112" />
  }, {
    id: '02',
    title: 'Mund/Rachen',
    desc: 'Gewebe vibriert → tiefer, "röhrender" Sound',
    icon: <Mic className="w-6 h-6 text-[#0f172a]" data-id="element-113" />
  }, {
    id: '03',
    title: 'Position',
    desc: "Rückenlage macht's automatisch schlimmer",
    icon: <BedDouble className="w-6 h-6 text-[#0f172a]" data-id="element-114" />
  }];
  return <section className="w-full bg-[#1e293b] py-24 px-4 md:px-6 relative overflow-hidden" data-id="element-115">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-[#2dd4bf] opacity-5 blur-[100px] rounded-full pointer-events-none" data-id="element-116"></div>

      <div className="max-w-3xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-bold text-[#faf5ef] mb-4" data-id="element-119">
            Schnarchen hat 3 Haupt-Ursachen
          </h2>
          <p className="text-[#2dd4bf] font-medium text-lg" data-id="element-120">
            (und du brauchst nur herausfinden, welche bei dir dominiert)
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-121">
          {zones.map((zone, index) => <motion.div key={zone.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className="bg-[#0f172a] p-6 rounded-2xl border border-[#334155] hover:border-[#2dd4bf]/50 transition-colors duration-300 group" data-id="element-122">
              <div className="flex justify-between items-start mb-6" data-id="element-123">
                <span className="text-4xl font-black text-[#1e293b] group-hover:text-[#2dd4bf]/20 transition-colors duration-300" data-id="element-124">
                  {zone.id}
                </span>
                <div className="bg-[#2dd4bf] p-2 rounded-lg shadow-lg shadow-[#2dd4bf]/20" data-id="element-125">
                  {zone.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-[#faf5ef] mb-3" data-id="element-126">
                {zone.title}
              </h3>
              <p className="text-[#94a3b8] leading-relaxed" data-id="element-127">{zone.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center max-w-xl mx-auto" data-id="element-128">
          <p className="text-lg text-[#cbd5e1]" data-id="element-129">
            Wenn du den falschen Hebel ziehst, fühlt es sich an wie: <br data-id="element-130" />
            <span className="italic text-[#94a3b8]" data-id="element-131">"Bei mir klappt nix."</span>
          </p>
        </motion.div>
      </div>
    </section>;
}